
const EnvironmentStatus = (props) => {
    return (
        <div>{props.row.original.status}</div>
    );
}
export default EnvironmentStatus;
